import { BarChart } from "@/components/analytics";
import { KpiReadout } from "@/components/ui/kpi-readout";

interface TargetData {
  numeric?: { max: number; min: number; std: number; mean: number };
  categorical?: Array<{ value: string; count: number; ratio: number }>;
}

interface TargetVizProps {
  data: TargetData;
}

export function TargetViz({ data }: TargetVizProps) {
  if (!data) return <p className="text-xs text-muted">No target data available.</p>;

  // Categorical target (classification)
  if (data.categorical) {
    return (
      <div>
        <h3 className="mb-3 font-mono text-sm font-semibold text-navy-600 dark:text-zinc-300">
          Target Distribution
        </h3>
        <BarChart data={data.categorical} dataKey="count" nameKey="value" height={300} />
      </div>
    );
  }

  // Numeric target (regression)
  if (data.numeric) {
    return (
      <div className="space-y-6">
        {/* Statistics KPIs */}
        <div className="grid grid-cols-4 gap-px rounded-[14px] border border-line bg-line overflow-hidden">
          <KpiReadout label="Mean" value={data.numeric.mean.toFixed(2)} />
          <KpiReadout label="Min" value={data.numeric.min.toFixed(2)} />
          <KpiReadout label="Max" value={data.numeric.max.toFixed(2)} />
          <KpiReadout label="Std Dev" value={data.numeric.std.toFixed(2)} />
        </div>
      </div>
    );
  }

  return <p className="text-xs text-muted">No target statistics available.</p>;
}
